import { useAppStore } from "../../stores/RootStore";
import { useFetch } from "../useFetch";
import { useEffect } from "react";
import { Division } from "../../types/types";
import _ from "lodash";

export const useRefreshDivisions = () => {
  const setDivisions = useAppStore(store => store.setDivisions);
  const setCurrentDivision = useAppStore((store) => store.setCurrentDivision);

  const [{ response: divisionsData }, doFetchDivisions] = useFetch(`/directories/divisions`);

  useEffect(() => {
    let divisions = divisionsData?.data as unknown as Division[];
    if (divisions) {
      setDivisions(divisions);
      setCurrentDivision(
        _.orderBy(
          divisions?.filter((d: Division) => d.attributes.depth === 0),
          "id",
          "asc"
        )[0]
      );
    };
  }, [divisionsData]);

  return doFetchDivisions;
};
